// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgPriceCapIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M19.746 10H1.006c-.38 0-.73.21-.9.55-.33.67.15 1.45.9 1.45h2.44a8.3 8.3 0 0 0 0 2h-2.44c-.38 0-.73.21-.89.55-.34.67.14 1.45.89 1.45h2.9c1.24 3.49 4.56 6 8.48 6 1.74 0 3.36-.49 4.74-1.35.69-.43.82-1.39.24-1.97-.42-.42-1.07-.47-1.57-.15-.99.62-2.15.97-3.41.97a6.48 6.48 0 0 1-5.76-3.5h5.14c.38 0 .73-.21.89-.55.33-.66-.15-1.45-.89-1.45h-5.8c-.05-.33-.08-.66-.08-1s.03-.67.08-1h13.78c.55 0 1-.45 1-1s-.45-1-1-1m-7.36-3.5c1.25 0 2.42.36 3.42.97.5.31 1.15.26 1.57-.16.58-.58.45-1.53-.25-1.96A9.03 9.03 0 0 0 12.386 4c-3.12 0-5.85 1.59-7.47 4h3.32c1.13-.94 2.57-1.5 4.14-1.5z" />
  </g>
);
export default SvgPriceCapIcon;
SvgPriceCapIcon.displayName = 'SvgPriceCapIcon';
